import request from '@/common/request'
export default {
  queryTodo: params => {
    return request({
      url: '/flow/getTodo',
      method: 'get',
      params
    })
  },
  queryMyApply: params => {
    return request({
      url: '/flow/getMyApply',
      method: 'get',
      params
    })
  },
  queryDone: params => {
    return request({
      url: '/flow/getDone',
      method: 'get',
      params
    })
  },
  audit:data =>{
    return request({
      url: '/flow/audit',
      method: 'post',
      data
    })
  },
  closeFlow:params =>{
    return request({
      url: '/flow/close',
      method: 'POST',
      params
    })
  },
}



// WEBPACK FOOTER //
// ./src/api/modules/audit.js